import { HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { throwError } from "rxjs";
import { catchError, finalize } from "rxjs/operators";
import { LocalStorageService } from "./local-storage.service";

@Injectable()
export class HttpRequestInterceptor implements HttpInterceptor {
    apiNum: number = 0;
    constructor(private localStorageService: LocalStorageService) {}

    intercept(req: HttpRequest<any>, next: HttpHandler) {
        try {
            let token: string = this.localStorageService.getAccessToken();
            if (!req.headers.has("Authorization") && token) {
                req = req.clone({
                    setHeaders: { Authorization: `Bearer ${token}` },
                });
            }

            if (this.apiNum == 0) this.apiNum++;

            return next.handle(req).pipe(
                finalize(() => {
                    --this.apiNum;
                }),
                catchError((err) => {
                    console.error(err);
                    if (err.status === 401) {
                        err.error = "Session expired";
                        this.localStorageService.clearLocalStorage();
                    } else if (err.status === 0) {
                        err.error = "Unable connect to server.";
                    }
                    return throwError(err.error);
                }),
            );
        } catch (error) {
            return next.handle(req);
        }
    }
}
